<template>
  <div>
    <div class="md-layout md-gutter mt-2">
      <div class="md-layout-item md-size-80">
        <h1 class="md-title">
          {{ graphicalId ? 'Editar' : 'Cadastrar' }} Conjunto de imagens
        </h1>
      </div>
      <div class="md-layout-item" style="text-align: right">
        <md-button class="md-icon-button md-list-action" @click="closeForm">
          <md-icon class="md-size-2x"> close </md-icon>
        </md-button>
      </div>
    </div>

    <form action="" class="md-layout" @submit.prevent="submit">
      <md-field :class="getValidationClass('titulo')">
        <label for="titulo">Título</label>
        <md-input id="titulo" v-model="form.titulo" />
        <span v-if="$v.form.titulo" class="md-error">titulo obrigatório</span>
      </md-field>
      <md-field :class="getValidationClass('descricao')">
        <label for="descricao">Descricao</label>
        <md-input id="descricao" v-model="form.descricao" />
      </md-field>
      <div style="text-align: right; width: 100%">
        <md-button class="md-raised md-accent" @click="() => closeForm()">
          Cancelar
        </md-button>
        <md-button type="submit" class="md-raised md-primary" @click="sendData">
          {{ graphicalId ? 'Editar' : 'Cadastrar' }}
        </md-button>
      </div>
    </form>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

import http from '../../../utils/http'

export default {
  name: 'GraphicalForm',
  mixins: [validationMixin],
  props: {
    localId: {
      type: String,
      required: true,
    },
    graphicalId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      form: {
        titulo: null,
        descricao: null,
      },
    }
  },
  validations: {
    form: {
      titulo: { required },
    },
  },
  beforeMount() {
    if (this.graphicalId) {
      this.buscarGraphical()
    }
  },
  methods: {
    async buscarGraphical() {
      const response = await http.get(`graphical-view/` + this.graphicalId)

      this.form.titulo = response.titulo
      this.form.descricao = response.descricao
    },
    closeForm() {
      this.$emit('close')
    },
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty,
        }
      }
    },
    async sendData() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      let response

      if (this.graphicalId) {
        response = await http.put(`graphical-view`, {
          id: this.graphicalId,
          ...this.form,
        })
      } else {
        response = await http.post(`graphical-view`, {
          ...this.form,
        })
      }

      if (response) {
        this.$emit('update')
        this.$emit('close')
      }
    },
  },
}
</script>

<style scoped></style>
